// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_format from "../../../../../node_modules/rescript/lib/es6/caml_format.js";

function getAppLinkingMinVersion(param) {
  return 5260;
}

function getClipboardMinVersion(param) {
  return 5261;
}

function getRnRHeaderRemovalVersion(param) {
  return 5770;
}

function getRnRHeaderRemovalVersionCode(param) {
  return 254;
}

function getIntegerFromAppVersion(version) {
  var replaceRegex = /[.]/g;
  var dotRemovedString = version.replace(replaceRegex, "");
  if (dotRemovedString === "") {
    return 0;
  } else {
    return Caml_format.caml_int_of_string(dotRemovedString);
  }
}

export {
  getAppLinkingMinVersion ,
  getClipboardMinVersion ,
  getRnRHeaderRemovalVersion ,
  getRnRHeaderRemovalVersionCode ,
  getIntegerFromAppVersion ,
  
}
/* No side effect */
